// src/com/dc_temp_info/DcTemperature.js
import React, { useState } from 'react';
import TopViewControl from '../../common/TopViewControl';
import ViewTabs from '../../common/ViewTabs';
import DcTempInfo from './DcTempInfo';
import DcTempBreakHis from '../dc_temp_break_his/DcTempBreakHis';

const DcTempCommand = {DcTempBreakHis:1, DcTempInfo:2};

const ViewMetaInfo = [
    {id:DcTempCommand.DcTempBreakHis, label:'센터별 온도이탈 이력'},
    {id:DcTempCommand.DcTempInfo, label:'센터별 기준온도'},
];

export default function DcTemperature() {
    const [selectedTabId, setSelectedTabId] = useState(ViewMetaInfo[0].id);

    const onChangeTab = (v) => {
        setSelectedTabId(v);
    };

    const viewTabs = <ViewTabs selectedTabId={selectedTabId} viewMetas={ViewMetaInfo} onChangeTab={onChangeTab} />;

    return(
        <TopViewControl>
            {
                (() => {
                    if(selectedTabId===DcTempCommand.DcTempInfo) return <DcTempInfo viewServiceTags={viewTabs} />;
                    else return <DcTempBreakHis viewServiceTags={viewTabs} />;
                })()
            }
        </TopViewControl>
    );
}